import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import queryString from 'query-string';
import Alert from '../../utils/Alert';
import Spinner from '../../components/generics/Spinner';
import { InventoryAuditTable, EmptyTable } from '../../components/inventories/InventoryAuditList';
import ModalUploadFile from '../../components/inventories/ModalUploadFile';
import { STARTING_PAGE } from '../../constants/constants';

import {
  fetchAudits,
  fetchAuditsSuccess,
  fetchAuditsFailure,
  createAudit,
  createAuditSuccess,
  createAuditFailure,
  csvSubmit,
  csvSubmitSuccess,
  csvSubmitFailure,
} from "../../store/inventories/actions";
import { withRouter } from "utils/WithRouter";

export class InventoryAuditListContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      scanned_items: [],
      currentPage: 1,
      isOpenUploadFileModal: false,
    };
    this.alertRef = React.createRef();
  }

  componentDidMount(){
    const params = queryString.parse(this.props.location.search);
    const currentPage = params.page ? params.page : STARTING_PAGE;
    this.setState({ currentPage }, () => {
      this.props.fetchAudits(currentPage);
    });
  }

  // ---------------------------------------------------------------------------
  // Pagination handling
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let currentPage = data.selected + 1;
    if(currentPage !== this.state.currentPage){
      this.setState({ currentPage }, () => {
          let params = {};
          params.page = currentPage;
          this.props.history.push({
            search: queryString.stringify(params)
          });
          this.props.fetchAudits(currentPage);
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Audit management
  // ---------------------------------------------------------------------------
  startAudit = () => {
    this.props.createAudit({temporary_info: null}, this.props);
  };

  deactivateItems = () => {
    //agregar action para pegarle al backend
  };

  openUploadFileModal = () => {
    this.setState({
      isOpenUploadFileModal: true
    });
  };

  closeUploadFileModal = () => {
    this.setState({
      isOpenUploadFileModal: false
    });
  };

  handleDeactivateCSV = (csv) => {
    this.setState({
      isOpenUploadFileModal: false
    });
    this.props.csvSubmit(csv, this.alertRef);
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    return (
        <div className="animated fadeIn shipment">
          <Alert ref={this.alertRef}/>
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <span><i className="fa fa-list-ol mr-05"></i>Inventory Audits</span>
              <span className="btn btn-primary m-0" onClick={this.openUploadFileModal}>Upload CSV To Deactivate</span>
              <span className="btn btn-primary m-0" onClick={this.startAudit}>Start New Audit</span>
            </div>
            <div className="card-block p-0">
              {/* Table */}
              {this.props.inventoryAuditList.audits.length === 0 ?
                  <EmptyTable />
              :
                  <InventoryAuditTable list={this.props.inventoryAuditList.audits} />
              }
            </div>
            {/* Pagination */}
            {this.props.inventoryAuditList.pages > 1 &&
              <ReactPaginate pageCount={this.props.inventoryAuditList.pages}
                             pageRangeDisplayed={2}
                             marginPagesDisplayed={1}
                             previousLabel="<"
                             nextLabel=">"
                             onPageChange={this.handlePageRequest}
                             initialPage={this.state.currentPage-1}
                             disableInitialCallback={true}
                             containerClassName="pagination"
                             pageClassName="page-item"
                             pageLinkClassName="page-link"
                             activeClassName="page-item active"
                             previousClassName="paginate_button previous"
                             nextClassName="paginate_button next"
                             disabledClassName="page-item disabled"
                             forcePage={this.state.currentPage-1}/>
            }
          </div>
          {/* Spinner */}
          {this.props.inventoryAuditList.loading && <Spinner />}
          {/* Modal for Upload CSV */}
          {this.state.isOpenUploadFileModal &&
            <ModalUploadFile
              isModalOpen={this.state.isOpenUploadFileModal}
              closeModal={this.closeUploadFileModal}
              onSubmit={this.handleDeactivateCSV}
            />}
        </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    inventoryAuditList: state.inventories.inventoryAuditList
  };
};

const mapDispatchToProps = (dispatch) => {
  const finished = (id, props) => {
    props.history.push(`/inventory/audit/${id}/edit`);
  }
  return {
    fetchAudits: (page) => {
      dispatch(fetchAudits(page)).payload.then((response) => {
        dispatch(fetchAuditsSuccess(response.data))
      }, (error) => {
        dispatch(fetchAuditsFailure(error));
      });
    },
    createAudit: (data, props) => {
      dispatch(createAudit()).payload.then((response) => {
        dispatch(createAuditSuccess(response.data));
        finished(response.data.id, props);
      }, (error) => {
        dispatch(createAuditFailure(error));
      });
    },
    csvSubmit: (csv, alertRef) => {
      dispatch(csvSubmit(csv)).payload.then((response) => {
        dispatch(csvSubmitSuccess(response.data))
        alertRef.current.sendAlert(
          "Inventory deactivation task has started. An email will be sent when it's finished.",
          "success");
      }, (error) => {
        dispatch(csvSubmitFailure(error))
        alertRef.current.sendAlert('Something went wrong!')
      })
    }
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(InventoryAuditListContainer));
